module.exports = __webpack_public_path__ + "static/media/file.3aa3003c.svg";